import { apiFetch } from "../../api";
import { BASE_URL as u } from "../../../commonUrls";

const BASE_URL = `${u}/stock-trade`;

const fetchWithFallback = async (primaryUrl, fallbackUrl, options) => {
  const primary = await apiFetch(primaryUrl, options);
  if (primary.ok || primary.status !== 404 || !fallbackUrl) {
    return primary;
  }
  return apiFetch(fallbackUrl, options);
};

export async function getTrades() {
  const res = await apiFetch(`${BASE_URL}/user`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function getTradesByAccount(accountId) {
  const res = await apiFetch(`${BASE_URL}/account/${accountId}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function createTrade(payload) {
  const res = await apiFetch(BASE_URL, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function updateTrade(id, payload) {
  const res = await apiFetch(`${BASE_URL}/${id}`, {
    method: "PUT",
    body: JSON.stringify(payload),
  });
  return res.json();
}

export async function deleteTrade(id) {
  return apiFetch(`${BASE_URL}/${id}`, { method: "DELETE" });
}

export async function getPositionSnapshot() {
  const res = await apiFetch(`${BASE_URL}/position`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function getPositionSnapshotByAccount(accountId) {
  const res = await apiFetch(`${BASE_URL}/position/account/${accountId}`);
  if (!res.ok) return [];
  const data = await res.json();
  return Array.isArray(data) ? data : [];
}

export async function getAllocationSummary() {
  const res = await apiFetch(`${BASE_URL}/position/summary`);
  if (!res.ok) return { totalInvested: 0, sectorBuckets: [], capBuckets: [] };
  return res.json();
}

export async function getPerformanceSummary() {
  const res = await apiFetch(`${BASE_URL}/performance`);
  if (!res.ok) return { rows: [] };
  return res.json();
}

export async function getPortfolioHealth() {
  const res = await apiFetch(`${BASE_URL}/health`);
  if (!res.ok) {
    return {
      totalInvested: 0,
      totalRealizedPnl: 0,
      totalUnrealizedPnl: 0,
      totalPnl: 0,
      sectorBuckets: [],
      capBuckets: [],
      topPositions: [],
      riskSignals: [],
    };
  }
  return res.json();
}

export async function getCapitalGains() {
  const res = await apiFetch(`${BASE_URL}/capital-gains`);
  if (!res.ok) return { financialYears: [], dataIntegrityIssues: [] };
  return res.json();
}

export async function getCapitalGainsByAccount(accountId) {
  const res = await apiFetch(`${BASE_URL}/capital-gains/account/${accountId}`);
  if (!res.ok) return { financialYears: [], dataIntegrityIssues: [] };
  return res.json();
}

export async function getTradeStats() {
  const res = await apiFetch(`${BASE_URL}/stats`);
  if (!res.ok) {
    return {
      totalClosedPositions: 0,
      winningPositions: 0,
      winRatePercent: 0,
      avgRMultiple: 0,
      rMultipleSampleSize: 0,
      strategyBreakdown: [],
    };
  }
  return res.json();
}

export async function getTradeStatsByAccount(accountId) {
  const res = await apiFetch(`${BASE_URL}/stats/account/${accountId}`);
  if (!res.ok) {
    return {
      totalClosedPositions: 0,
      winningPositions: 0,
      winRatePercent: 0,
      avgRMultiple: 0,
      rMultipleSampleSize: 0,
      strategyBreakdown: [],
    };
  }
  return res.json();
}

export async function importTradesCsv(accountId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiFetch(`${BASE_URL}/import/account/${accountId}`, {
    method: "POST",
    body: formData,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "CSV import failed.");
  }
  return res.json();
}

export async function previewTradesCsv(accountId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const res = await apiFetch(`${BASE_URL}/import/preview/account/${accountId}`, {
    method: "POST",
    body: formData,
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "CSV preview failed.");
  }
  return res.json();
}

export async function commitTradesImport(accountId, payload) {
  const res = await apiFetch(`${BASE_URL}/import/commit/account/${accountId}`, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(text || "Import commit failed.");
  }
  return res.json();
}
